import EventsFeedDataProvider from 'components/eventsFeed/EventFeedDataProvider';
import ChartContainer from 'components/GQChart/ChartContainer';
import { IMobxRootState } from '../../RootStore';
import { E_RISK_TYPE, VIEW } from 'interfaces';
import { inject } from 'mobx-react';
import useInitCountryDim from 'hooks/useInitCountryDim';
import useInitChart from 'hooks/useInitChart';
import { FGStack } from '@fg/design-system';
import { CountryRiskPicker } from 'components/Pickers/CountryRiskPicker';
import { PickerDrawer } from 'components/Pickers/PickerDrawer';
import { useViewUrlSync } from 'services/urlState/useViewUrlSync';
import { singleCountrySchema } from 'services/urlState/viewSchemas';
import React from 'react';

export const CountryGraphPage = React.memo(() => {
    useViewUrlSync(singleCountrySchema);
    return (
        <FGStack style={{ height: '100%' }}>
            <PickerDrawer title="Single Country Risks" side="right" defaultOpen>
                <CountryRiskPicker />
            </PickerDrawer>
            <div
                style={{
                    flex: 1,
                }}>
                <CountryGraph />
            </div>
            <EventsFeedDataProvider />
        </FGStack>
    );
});

type CountryGraphProps = {
    height?: number;
    countries?: number[];
};

export const CountryGraph = inject(
    ({ chartStore, countryStore }: IMobxRootState) => {
        return {
            height: chartStore.height,
            countries: countryStore.currentCountryList,
        };
    }
)(({ height, countries }: CountryGraphProps) => {
    useInitChart();
    const ready = useInitCountryDim({
        riskType: E_RISK_TYPE.DIMENSIONS,
        multiCountry: false,
        multiRisk: true,
    });

    if (!ready) {
        return null;
    }
    return (
        <ChartContainer
            height={height}
            activeView={VIEW.COUNTRY_GRAPH}
            changeDataWhenDragStop={true}
        />
    );
});
